var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevops2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3455_7601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6172 27.0121C17.6172 17.3458 25.4532 9.50977 35.1195 9.50977H86.5985C96.2647 9.50977 104.101 17.3458 104.101 27.0121V78.5915C104.101 88.2577 96.2647 96.0938 86.5984 96.0938H35.1195C25.4532 96.0938 17.6172 88.2577 17.6172 78.5915V27.0121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1195 10.0567H86.5985C95.9626 10.0567 103.554 17.6479 103.554 27.0121V78.5915C103.554 87.9556 95.9626 95.5468 86.5984 95.5468H35.1195C25.7553 95.5468 18.1641 87.9556 18.1641 78.5915V27.0121C18.1641 17.6479 25.7553 10.0567 35.1195 10.0567Z",
    stroke: "#B1C1CF",
    strokeWidth: 1.09389
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2618 57.1984H49.1738C48.0547 57.1984 47.1445 56.2883 47.1445 55.1691V49.0812C47.1445 47.962 48.0547 47.0519 49.1738 47.0519H55.2618C56.3809 47.0519 57.2911 47.962 57.2911 49.0812V55.1691C57.2911 56.2883 56.3809 57.1984 55.2618 57.1984ZM49.1738 49.0812V55.1691H55.2618V49.0812H49.1738ZM62.3644 66.3303C61.9971 66.3303 61.6338 66.3161 61.2726 66.2897C56.8568 65.9529 52.7901 63.5177 50.3924 59.7756L52.1021 58.6798C53.1208 60.2665 54.4925 61.5962 56.1101 62.5651C57.7276 63.5341 59.5472 64.116 61.4268 64.2655C61.7363 64.2888 62.0488 64.301 62.3644 64.301V66.3303ZM69.467 66.3303L67.3362 65.3157C65.6113 64.5039 64.3937 62.6776 64.3937 60.7497V54.1544H74.5402V60.7497C74.5402 62.6776 73.4241 64.5039 71.5977 65.3157L69.467 66.3303ZM66.423 56.1838V60.7497C66.423 61.9673 67.1333 62.982 68.1479 63.4893L69.467 64.0981L70.786 63.4893C71.8007 62.982 72.5109 61.8658 72.5109 60.7497V56.1838H66.423ZM73.832 48.0665C74.2927 49.3673 74.5402 50.7259 74.5402 52.1251H76.5696C76.5696 50.7351 76.3676 49.3774 75.977 48.0665H73.832ZM73.5256 46.0372H70.4816C69.3625 46.0372 68.4523 45.1271 68.4523 44.0079V40.9639C68.4523 39.8448 69.3625 38.9346 70.4816 38.9346H73.5256C74.6448 38.9346 75.5549 39.8448 75.5549 40.9639V44.0079C75.5549 45.1271 74.6448 46.0372 73.5256 46.0372ZM70.4816 40.9639V44.0079H73.5256V40.9639H70.4816ZM66.423 38.5115C65.106 38.1183 63.7388 37.9191 62.3644 37.92C59.9783 37.915 57.6297 38.5134 55.5368 39.6593C53.4439 40.8053 51.6747 42.4617 50.3935 44.4746L52.1021 45.5705C53.5791 43.2498 55.8006 41.4997 58.4025 40.6071C61.0045 39.7144 63.8325 39.7322 66.423 40.6575V38.5115Z",
    fill: "#243251"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3455_7601",
    x: 0.114895,
    y: 0.758619,
    width: 121.489,
    height: 121.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.75115
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.75115
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3455_7601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3455_7601",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops2);
export default __webpack_public_path__ + "static/media/Devops2.1e3bddc4f30cfc0fc8ef1a1003882acb.svg";
export { ForwardRef as ReactComponent };